const formatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
})

export function formatCurrency(str: string | number): string {
  if (typeof str === 'string' && str.endsWith('€')) {
    str = parseCurrency(str)
  }

  return formatter.format(Number(str) / 100)
}

export function parseCurrency(val: string | number): number {
  if (typeof val === 'string') {
    const num = val
      .split(/\s|€/)[0]
      .replace(/\.(\d\d)$/, ',$1')
      .replaceAll('.', '')
      .replace(',', '.')
    return Number((Number(num) * 100).toFixed(0))
  } else {
    return val
  }
}
